import { createStyles } from '@codeleap/styles'
import { GridComposition } from '@codeleap/web'
import { StyleRegistry } from '../styles'

const createGridVariant = createStyles<GridComposition>

export const GridStyles = {
  default: createGridVariant((theme) => {
    return {
      wrapper: {
        minHeight: '30vh',
        ...theme.presets.column,
        ...theme.presets.fullWidth,
        ...theme.presets.relative,
      },
      innerWrapper: {
        ...theme.presets.fullWidth,
      },
      refreshControl: {
        backgroundColor: theme.colors.neutral1,
        borderRadius: theme.borderRadius.rounded,
        zIndex: 2,
        ...theme.presets.absolute,
        left: '50%',
        transform: 'translateX(-50%)',
        ...theme.spacing.padding(0.5),
        pointerEvents: 'none',
      },
    }
  }),
  hiddenSeparator: createGridVariant(theme => ({
    separator: {
      ...theme.presets.fullWidth,
      height: theme.values.innerSpacing.value,
    },
  })),
  lineSeparators: createGridVariant(theme => ({
    separator: {
      height: theme.values.pixel,
      backgroundColor: theme.colors.neutral5,
    },
  })),
}

StyleRegistry.registerVariants('Grid', GridStyles)
